'use strict';

var _this;
class MenuApp {

	constructor() {

		_this = this;
		_this.attachEventDesktop();
		_this.attachEventMobile();
		_this.linkCapitoloPrev = '#';
		_this.linkCapitoloNext = '#';
		_this.currentCapitoloId = '';
		_this.currentCapitoloLabel = '';
		_this.currentSectionLabel = '';
		_this.clickOpenCapitolo = false;

		//s_this.setCurrentCapitolo();
		_this.setFromDomLinkCapitoloPrevNext($('body'));
		_this.attachEventParagraphNav();

		let capitoloOpen = $('.content-capitoli.show').attr('id');
		if(capitoloOpen != undefined && capitoloOpen != null && capitoloOpen != '')
			_this.setCurrentCapitolo(capitoloOpen);

		_this.setLabelNavIndicatorMobile();
		_this.attachEventAcordionSection();

	}

	attachEventAcordionSection(){

		$('.row-accordion').on('shown.bs.collapse', function () {
			// do something…
			//console.log('open section',$(this),$(this).position().top);

			if(!_this.clickOpenCapitolo){

				$('#indice').animate({
					//scrollTop:  (paragraph.offset().top - $('.header-app-content').height()) -150,
					scrollTop:  '+='+$(this).position().top,
				}, 200, function() {
					// Animation complete.
				});

			}
			_this.clickOpenCapitolo = false;

		});

		$('.sub-accordion').on('shown.bs.collapse', function () {
			// do something…
			//console.log('open capitolo');
			_this.clickOpenCapitolo = true;

		});


	}

	attachEventParagraphNav(){
		$('.paragrafo-nav').click(function(e){
			e.preventDefault();

			//console.log('currentCapitoloId',_this.currentCapitoloId);
			//console.log('para currentCapitoloId',$(this).parents('.content-capitoli').attr('id'));
			//console.log('para currentCapitoloId',$(this).parents('.content-capitoli').prev().find('.capitolo-n').html());
			let capitoloClicked = $(this).parents('.content-capitoli').attr('id');


			if(_this.currentCapitoloId != capitoloClicked)
				return;

			let slugParagraph = $(this).attr('data-slug-paragraph');
			let paragraph = $('#'+slugParagraph);

			//console.log('ssss',$('.content-capitolo').length);
			//console.log('paragraph',slugParagraph);
			if(paragraph == undefined)
				return;

			let indexParagraph = paragraph.index();
			let heightToScroll = 0;

			$('#indice').find('li.active').removeClass('active');
			$(this).parent('li').addClass('active');

			if($('#btn-indice-mobile').hasClass('open'))
				$('#btn-indice-mobile').click();
			// console.log('click qui', paragraph.offset().top , $('.header-app-content').height());

			//console.log('click qui', paragraph.offset().top , paragraph.position().top, paragraph.is(':first-child'), paragraph.index());


			//$('.content-capitolo .paragraph-wrap').each(function (index) {
			$('.wrap-barba').last().find('.content-capitolo .paragraph-wrap').each(function (index) {

				//console.log('height ::' , $(this).height());

				if(indexParagraph > index)
					heightToScroll += $(this).height();
			});

			//console.log('heightToScroll', heightToScroll);

			// var rect = document.getElementById(slugParagraph).getBoundingClientRect();
			// console.log(rect.top, rect.right, rect.bottom, rect.left);

			let adjustHeightScroll = $('.header-app-content').height() + $('.info-sezione').height() + $('.info-capitolo').height() + $('.wrap-info-aggiuntive').height();
			$('.app-wrap-content').animate({
				//scrollTop:  (paragraph.offset().top - $('.header-app-content').height()) -150,
				scrollTop:  heightToScroll + adjustHeightScroll - 35,
			}, 400, function() {
				//console.log('offset',$('#'+slugParagraph).offset().top);
				// Animation complete.
			});

			//_this.currentCapitoloId = $(this).parent('.content-capitoli').attr('id');

			_this.setCurrentCapitolo(capitoloClicked);
			_this.setLabelNavIndicatorMobile();

		});
	}

	setLabelNavIndicatorMobile(){
		$('#current-section-capitolo div').html(_this.currentSectionLabel + ' / ' + _this.currentCapitoloLabel);
	}

	setCurrentCapitolo(idCapitolo){

		// if(idCapitolo == undefined)
		// 	idCapitolo = $('.content-capitoli.show').attr('id');

		if(idCapitolo != undefined)
			_this.currentCapitoloId = idCapitolo;

		//close accordion capitolo
		$('#indice').find('.header-accordion-capitolo[aria-expanded="true"]').attr('aria-expanded','false');
		$('#indice').find('.content-capitoli.show').removeClass('show');
		//close accordion section
		$('#indice').find('.header-accordion-section[aria-expanded="true"]').parent().next().removeClass('show');
		$('#indice').find('.header-accordion-section[aria-expanded="true"]').attr('aria-expanded','false');

		if(idCapitolo != undefined){
			$('#'+idCapitolo).prev().find('.header-accordion-capitolo').attr('aria-expanded','true');
			$('#'+idCapitolo).addClass('show');
			//$('#'+idCapitolo).parents('.row-accordion').find('.sezione-header').attr('aria-expanded','true');
			$('#'+idCapitolo).parents('.row-accordion').find('.sezione-header div').attr('aria-expanded','true');
			$('#'+idCapitolo).parents('.row-accordion').find('.sezione-header').next().addClass('show');
			_this.currentCapitoloLabel = $('#'+idCapitolo).prev().find('.capitolo-n').html();
			_this.currentSectionLabel = $('#'+idCapitolo).parent().parent().prev().find('.sezione-n').html();
		}
	}

	setFromDomLinkCapitoloPrevNext(objBase){

		let linkCapitoloPrev = objBase.find('#capitolo-prev').attr('href');
		let linkCapitoloNext = objBase.find('#capitolo-next').attr('href');

		_this.linkCapitoloPrev = linkCapitoloPrev;
		_this.linkCapitoloNext = linkCapitoloNext;
		_this.setNavCapitoliMobile(linkCapitoloPrev,linkCapitoloNext);

	}

	setNavCapitoliMobile(linkPrev,linkNext){

		$('#btn-capitolo-prev').attr('href',linkPrev);
		$('#btn-capitolo-next').attr('href',linkNext);

		if(linkPrev == '#' || linkPrev == undefined)
			$('#btn-capitolo-prev').attr('disabled','disabled');
		else
			$('#btn-capitolo-prev').removeAttr('disabled');

		if(linkNext == '#' || linkNext == undefined)
			$('#btn-capitolo-next').attr('disabled','disabled');
		else
			$('#btn-capitolo-next').removeAttr('disabled');

	}

	attachEventDesktop(){
		$( 'aside .close-aside' ).click(function() {
			$( 'aside' ).addClass('closed');
			$( 'aside .user-info' ).hide();
			$( 'aside form' ).hide();
			$( 'aside .accordion' ).hide();
			$( this ).hide();
			$( 'section#app-content' ).addClass('large');
			$( '.open-aside' ).fadeIn();
			$( '#expand-aside' ).fadeIn();
		});

		$( 'aside .open-aside' ).click(function() {
			$( 'aside' ).removeClass('closed');
			$( '.open-aside' ).fadeOut();
			$( '#expand-aside' ).fadeOut();
			$( 'section#app-content' ).removeClass('large');
			//var r=setTimeout(function () {
			setTimeout(function () {
				$( 'aside .user-info' ).fadeIn();
				$( 'aside .close-aside' ).fadeIn();
				$( 'aside form' ).fadeIn();
				$( 'aside .accordion' ).fadeIn();
			}, 500);
		});
	}

	attachEventMobile(){
		// ASIDE MOBILE
		// PROFILE
		$( 'aside #btn-user-mobile' ).click(function() {
			$( '#profile' ).toggleClass('open');
			$( '#search' ).removeClass('open');
			$( '#indice' ).removeClass('open');
			$( this ).toggleClass('open');
			$( 'aside #btn-search-mobile' ).removeClass('open');
			$( 'aside #btn-indice-mobile' ).removeClass('open');
		});

		// SEARCH
		$( 'aside #btn-search-mobile' ).click(function() {
			$( '#search' ).toggleClass('open');
			$( '#profile' ).removeClass('open');
			$( '#indice' ).removeClass('open');
			$( this ).toggleClass('open');
			$( 'aside #btn-user-mobile' ).removeClass('open');
			$( 'aside #btn-indice-mobile' ).removeClass('open');
		});

		// INDICE
		$( 'aside #btn-indice-mobile' ).click(function() {
			$( '#indice' ).toggleClass('open');
			$( '#search' ).removeClass('open');
			$( '#profile' ).removeClass('open');
			$( this ).toggleClass('open');
			$( 'aside #btn-user-mobile' ).removeClass('open');
			$( 'aside #btn-search-mobile' ).removeClass('open');
		});

		// LINGUETTA
		$('.app-wrap-content').scroll(function(){
			if ($('.app-wrap-content').scrollTop() >= 50) {
				$('#current-section-capitolo').addClass('open');
			}
			else {
				$('#current-section-capitolo').removeClass('open');
			}
		});
	}



}

export default MenuApp


// WEBPACK FOOTER //
// ./scripts/components/menuApp.js